import { render, staticRenderFns } from "./event-detail-menu.vue?vue&type=template&id=2d708be5&scoped=true&"
import script from "./event-detail-menu.vue?vue&type=script&lang=js&"
export * from "./event-detail-menu.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-menu.vue?vue&type=style&index=0&id=2d708be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d708be5",
  null
  
)

export default component.exports